import { useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, Box, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../assests/EasyTrade2.png";
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import axios from "axios";

export const Navbar = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");

  const menuItems = [
    { text: "Home", path: "/home" },
    { text: "Register", path: "/register" },
    { text: "Login", path: "/" },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  // Implementation for fetching OTP logs
  const getOtpLogs = async() => {
    try{
      let res = await axios.get(`https://application.eterp.in/OtpLogs/master`);
      console.log("OtpLogs",res.data)
    }catch (error) {
      console.error("Error fetching OTP logs:", error);
    }
  };

  useEffect(() => {
    getOtpLogs();
  }, []);
  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "#2db7e8" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/home")}
          >
            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{
                width: 50,
                height: 50,
                backgroundColor: "#fff",
                p: 1,
                borderRadius: 1,
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.1)" },
              }}
            />
            {!isMobile && (
              <Typography
                variant="h6"
                sx={{
                  ml: 2,
                  fontWeight: 600,
                  letterSpacing: 1,
                  color: "#fff",
                }}
              >
                ET App
              </Typography>
            )}
          </Box>
          <FactCheckOutlinedIcon cursor="pointer" />

          {/* {isMobile ? (
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box display="flex" gap={3}>
              {menuItems.map((item) => (
                <Typography
                  key={item.text}
                  onClick={() => handleNavigate(item.path)}
                  sx={{
                    cursor: "pointer",
                    "&:hover": { color: "#fff", textDecoration: "underline" },
                    fontWeight: 500,
                  }}
                >
                  {item.text}
                </Typography>
              ))}
            </Box>
          )} */}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      {/* <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box
          sx={{ width: 200 }}
          role="presentation"
          onClick={() => setDrawerOpen(false)}
          onKeyDown={() => setDrawerOpen(false)}
        >
          <List>
            {menuItems.map((item) => (
              <ListItem
                button
                key={item.text}
                onClick={() => handleNavigate(item.path)}
              >
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer> */}
    </>
  );
};
